import { render, staticRenderFns } from "./DarkModeToggle.vue?vue&type=template&id=bc4fc2d8&scoped=true&"
import script from "./DarkModeToggle.vue?vue&type=script&lang=js&"
export * from "./DarkModeToggle.vue?vue&type=script&lang=js&"
import style0 from "./DarkModeToggle.vue?vue&type=style&index=0&id=bc4fc2d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4fc2d8",
  null
  
)

export default component.exports